import styled from 'styled-components';

export const SignatureDiv = styled.div`
  position: relative;

  #div_sign_footer_embed {
    .btn-primary-verde {
      background-color: 'red' !important;
    }
  }
`;

export const Title = styled.h5`
  color: ${({ color }) => color};
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const SucessText = styled.p`
  font-size: 16px;
  color: #4d4d4d;
  text-align: center;
`;

export const SucessContainer = styled.div`
  max-width: 400px;
  width: 100%;
  height: 312px;
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
